import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'exchange-rate-form',
  templateUrl: './exchange-rate-form.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class ExchangeRateFormComponent {
  /** FormArray of `{ currency, rate }` FormGroups — shared by reference with the parent form. */
  @Input() rates: FormArray;

  addRow() {
    this.rates.push(
      new FormGroup({
        currency: new FormControl('', Validators.required),
        rate: new FormControl(null, Validators.required),
      })
    );
  }

  removeRow(index: number) {
    this.rates.removeAt(index);
  }

  static buildRatesArray(rates: { [currency: string]: number }): FormArray {
    const array = new FormArray<FormGroup>(
      [],
      ExchangeRateFormComponent.duplicateCurrencyValidator
    );
    Object.keys(rates || {}).forEach((currency) => {
      array.push(
        new FormGroup({
          currency: new FormControl(currency, Validators.required),
          rate: new FormControl(rates[currency], Validators.required),
        })
      );
    });
    return array;
  }

  /** Invalidates the array as soon as two rows share the same currency code (case-insensitive), since
   * consumers silently let the last one win when building the `{ [currency]: rate }` payload. */
  static duplicateCurrencyValidator(control: AbstractControl): ValidationErrors | null {
    const codes = (control as FormArray).controls
      .map((row) => (row.get('currency')?.value || '').toString().toUpperCase())
      .filter((code) => code !== '');
    return new Set(codes).size !== codes.length ? { duplicateCurrency: true } : null;
  }
}
